var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 14.6654L11.5192 11.5117L14.6673 14.6654ZM13.2638 7.29694C13.2638 8.87894 12.6354 10.3961 11.5167 11.5148C10.3981 12.6334 8.88089 13.2619 7.2989 13.2619C5.7169 13.2619 4.1997 12.6334 3.08107 11.5148C1.96243 10.3961 1.33398 8.87894 1.33398 7.29694C1.33398 5.71495 1.96243 4.19775 3.08107 3.07911C4.1997 1.96048 5.7169 1.33203 7.2989 1.33203C8.88089 1.33203 10.3981 1.96048 11.5167 3.07911C12.6354 4.19775 13.2638 5.71495 13.2638 7.29694V7.29694Z",
    stroke: "#5E639B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/SearchBlue.acb304698e1c0b73cb9f1be632b8d2a7.svg";
export { ForwardRef as ReactComponent };